import { AccessCollectIcon } from './icons/AccessCollectIcon';

export function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-background">
      <AccessCollectIcon className="h-14 w-14 animate-pulse" />
      <p className="text-sm text-muted-foreground">Loading…</p>
    </div>
  );
}
